import Header from "../components/Header";
import RequestFormModal from "../components/RequestFormModal";
import React from "react";
import Footer from "./Footer";
import ReactGA from "react-ga4";
import {useLocation} from "react-router-dom";
import {useEffect} from "react";
import ResearchItem from "../components/ResearchItem";

const Reasearch: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return (
    <div className="bg-white flex flex-col min-h-screen">
      <Header />
      <div className="flex flex-col w-[84%] mx-auto flex-grow">
        <div className="my-3">
          <div className="font-bold text-[28px] lg:text-[37.5px] text-[#2A424B] my-3">
            Publications
          </div>
          <div className="text-valmidnight text-[16px]">
            <ResearchItem
              dateLabel="JANUARY 23, 2026"
              imageUrl="/Central Illustration.tiff"
              title="Epidemiology of Hypertrophic Cardiomyopathy in the United States From 2016 to 2023"
              authors="Butzner M, ElHabr AK, Farajkhah K, Chhatwal J, Ayer T, Gebrehiwet P, Shreay S, Riello III RJ, Desai NR, Owens AT, Abraham T."
              meta="JACC: Advances. 2026 Feb 1;5(2):102552."
              link="https://www.jacc.org/doi/abs/10.1016/j.jacadv.2025.102552"
            />
          </div>
        </div>
        <div className="mt-auto w-full py-8 flex justify-center">
          <button
            className="btn px-10 bg-valpeacock hover:text-valmidnight hover:border-color-valmidnight text-white w-[20vw]"
            onClick={() =>
              (
                document.getElementById("request") as HTMLDialogElement
              ).showModal()
            }>
            Research Request
          </button>
        </div>
        <RequestFormModal></RequestFormModal>
      </div>
      <Footer />
    </div>
  );
};

export default Reasearch;
